//import Example from './example';

document.addEventListener("DOMContentLoaded", () => {
    if (window.YouTubeOverlayInitialized) return;
    window.YouTubeOverlayInitialized = true;

    const ytPlayers = new Map();

    const initOverlayHandlers = () => {
        document.querySelectorAll(".js-oembed-play").forEach((button) => {
            button.addEventListener("click", function () {
                const container = this.closest(".image_and_emblems--video");
                const iframe = container.querySelector("iframe");

                if (!iframe) return;

                this.closest(".overlay").classList.add("overlay--hidden");

                // YouTube's iFrame API requires a unique ID...
                if (!iframe.id) {
                    iframe.id =
                        "yt-" + Math.random().toString(36).substring(2, 10);
                }

                // Create or reuse player
                if (!ytPlayers.has(iframe.id)) {
                    const player = new YT.Player(iframe.id, {
                        events: {
                            onReady: (event) => {
                                event.target.playVideo();
                            },
                        },
                    });
                    ytPlayers.set(iframe.id, player);
                } else {
                    ytPlayers.get(iframe.id).playVideo();
                }
            });
        });
    };

    const loadYouTubeAPI = () => {
        if (typeof YT === "undefined" || typeof YT.Player === "undefined") {
            const tag = document.createElement("script");
            tag.src = "https://www.youtube.com/iframe_api";
            const firstScript = document.getElementsByTagName("script")[0];
            firstScript.parentNode.insertBefore(tag, firstScript);
        } else {
            initOverlayHandlers();
        }
    };

    // YouTube API callback
    window.onYouTubeIframeAPIReady = () => {
        initOverlayHandlers();
    };

    loadYouTubeAPI();
});
